var MuiTab = {
/* put your new default props here */
};
export default MuiTab;
//# sourceMappingURL=MuiTab.js.map